import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    projectIdState: ""
}

const projectSlice = createSlice({
    name: "projectIdSet",
    initialState,
    reducers: {
        setProjectId: (state, actions) => {
            state.projectIdState = actions.payload
        }
    }

})

export const { setProjectId } = projectSlice.actions;
export default projectSlice.reducer;